export default "__VITE_ASSET__BBC9BdM2__"